import {
  ReactNode,
  DetailedHTMLProps,
  HTMLAttributes,
  ImgHTMLAttributes,
} from 'react'
import UntypedLazyload from './Lazyload'

type LazyloadProps = {
  src: string
  children?: ReactNode
} & (
  | ({
      type?: 'div' | undefined
    } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>)
  | ({
      type: 'img'
    } & DetailedHTMLProps<
      ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >)
  | ({
      type: 'li'
    } & DetailedHTMLProps<HTMLAttributes<HTMLLIElement>, HTMLLIElement>)
  | ({
      type: 'section'
    } & DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>)
)

export const Lazyload = UntypedLazyload as (props: LazyloadProps) => JSX.Element

export { default as Button } from './Button'
export { default as Footer } from './Footer'
export { default as Form } from './Form'
export { default as Hamburger } from './Hamburger'
export { default as Head } from './Head'
export { default as LanguageProvider } from './LanguageProvider'
export { default as Lightbox } from './Lightbox'
export { default as Link } from './Link'
export { default as Loading } from './Loading'
export { default as Map } from './Map'
export { default as MenuBar } from './MenuBar'
export { default as Modal } from './Modal'
export { default as Tabs } from './Tabs'
export { default as WorkModal } from './WorkModal'
